import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Card,
  Flex,
  Space,
  Group,
  Text,
  TextInput,
  SegmentedControl,
  Stack,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";

export default function RequestList({
  items = [],
  requestInfo = {
    url: `/retrieve-requests/`,
    data: {},
  },
  refresh,
  isIndex,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    search_value: "",
    status: "0",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder={t("search")}
            size="lg"
            value={filters.search_value}
            onChange={(e) =>
              setFilters({ ...filters, search_value: e.target.value })
            }
          />
          <SegmentedControl
            data={[
              { label: t("waiting"), value: "0" },
              { label: t("unapproved"), value: "1" },
              { label: t("approved"), value: "2" },
            ]}
            value={filters.status}
            onChange={(value) => setFilters({ ...filters, status: value })}
            size="xs"
            mt="sm"
          />
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/requests/${m.id}`,
          }))
        }
        displayFormatter={(item) => {
          return (
            <Card key={item.original.id}>
              <Group>
                <Text
                  fw={700}
                  component={Link}
                  to={`/requests/${item.original.id}`}
                  c="dark"
                >
                  {item.original.requested_for_formatted.name}
                </Text>
              </Group>
              <Text size="sm">
                {item.original.requested_by.full_name} requested on{" "}
                {new Date(item.original.created_at).toLocaleDateString()}
              </Text>
              <Stack>
                {item.original.surveys_info.map((survey) => (
                  <Text size="sm" key={survey.id}>
                    {survey.name} - {survey.company_employee.first_name}{" "}
                    {survey.company_employee.last_name}
                  </Text>
                ))}
              </Stack>
            </Card>
          );
        }}
      />
    </div>
  );
}
